export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_HABIT_USER_AREAS_REQUEST",
  SUCCESS: "ADMIN_FETCH_HABIT_USER_AREAS_SUCCESS",
  FAILURE: "ADMIN_FETCH_HABIT_USER_AREAS_FAILURE",

  SUCCESS_SINGLE: "ADMIN_FETCH_HABIT_USER_AREA_SUCCESS",
  UPDATE_SUCCESS: "ADMIN_UPDATE_HABIT_USER_AREA_SUCCESS",
  CREATE_SUCCESS: "ADMIN_CREATE_HABIT_USER_AREA_SUCCESS",
  DELETE_SUCCESS: "ADMIN_DELETE_HABIT_USER_AREA_SUCCESS",
}

export interface IUserArea {
  id: number;
  system_area_name: number;
  area_name: string;
  user: number;
  user_email: string;
}

interface NormalizedEntities {
  [key: string]: IUserArea;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
  error: any;
}
